import { render } from "./AdminAccountManageForm.vue?vue&type=template&id=0d644ea4&lang=true"
import script from "./AdminAccountManageForm.vue?vue&type=script&lang=js"
export * from "./AdminAccountManageForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__